import { applicantStore } from '@/store'
import { ObjectUtils } from '@/commons/utils/objects'
import { RequestGeneralError } from '@/store/entities'
import { ApplicationDocument, ValidationObserver } from '@/commons/types'

import {
    ApplicationType,
    validatorIds,
    ApplicationValidationFieldName,
    ApplicantApplierRelationType
} from '@/commons/constants/application'
import { ENVIRONMENT } from '@/commons/configuration'

type applicationContent = string | null | undefined | boolean | object

export class ApplicationUtils {
    static isFingerprintsRequired (applicationType: ApplicationType, personAge: number): boolean {
        if (applicationType === ApplicationType.ID_CARD) {
            return personAge >= ENVIRONMENT.fingerprintConstraints.requiredOnCardFromAge
        } else if (applicationType === ApplicationType.CITIZEN_PASSPORT) {
            return personAge >= ENVIRONMENT.fingerprintConstraints.requiredOnPassFromAge
        } else {
            return personAge >= ENVIRONMENT.fingerprintConstraints.requiredOnComboFromAge
        }
    }

    static getDocument (documentType: string): ApplicationDocument {
        return (applicantStore.getApplication as unknown as Record<string, ApplicationDocument>)[documentType]
    }

    static handleBackendError (fieldPath: string, errorCode: string, vm: ValidationObserver): void {
        if (fieldPath === ApplicationValidationFieldName.DISABILITY_CONFIRMATION) {
            ApplicationUtils.setValueByFieldPath(fieldPath, false)
            return
        }

        // There is not a use case where validator is not present on form or not in validatorIds
        if (!Object.prototype.hasOwnProperty.call(vm.errors, fieldPath) ||
            !Object.prototype.hasOwnProperty.call(validatorIds, fieldPath)) {
            throw new RequestGeneralError()
        }

        const validationErrors: Record<string, Array<string>> = {}
        validationErrors[fieldPath] = [errorCode]
        vm.setErrors(validationErrors)
    }

    static setValueByFieldPath (fieldPath: string, value: applicationContent): void {
        const application = applicantStore.getApplication as unknown as Record<string, applicationContent>
        const [referenceObject, referenceKey] = ObjectUtils.findContentReferenceAndKey(application, fieldPath)
        if (referenceObject && referenceKey) {
            referenceObject[referenceKey] = value
        }
    }

    static getApplicantRelationTitle (): string {
        let title = 'applicantInfo.title.applicant'

        switch (applicantStore.applicantRelationWithApplier) {
        case ApplicantApplierRelationType.CHILD:
            title = 'applicantInfo.title.child'
            break
        case ApplicantApplierRelationType.WARD:
            title = 'applicantInfo.title.ward'
            break
        }
        return title
    }
}
